import React from "react"
import type { WizardArchetype } from "../../../types"
import { ARCHETYPE_ICONS } from "../constants"

interface Props {
  archetypes: WizardArchetype[]
  onSelect: (archetype: WizardArchetype) => void
}

export default function ArchetypeStep({ archetypes, onSelect }: Props) {
  return (
    <section>
      <h1 className="font-display text-3xl sm:text-4xl font-semibold text-ink">
        Qual é o seu estabelecimento?
      </h1>
      <p className="mt-3 text-gray-600">
        O questionário e os POPs do seu PGRSS são montados sob medida pro seu tipo de negócio.
      </p>

      <div className="mt-8 grid sm:grid-cols-2 gap-4">
        {archetypes.map(archetype => (
          <button
            key={archetype.key}
            type="button"
            onClick={() => onSelect(archetype)}
            className="group text-left p-5 rounded-2xl border-2 border-brand-100 bg-white hover:border-brand-500 hover:shadow-lg hover:shadow-brand-900/5 transition-all"
          >
            <span className="text-3xl" aria-hidden="true">{ARCHETYPE_ICONS[archetype.key] || "🏥"}</span>
            <span className="mt-3 block font-semibold text-ink group-hover:text-brand-800">
              {archetype.label}
            </span>
            <span className="mt-1 block text-sm text-gray-500">
              {archetype.questions.length} perguntas · ~10 minutos
            </span>
          </button>
        ))}
      </div>

      <p className="mt-8 text-sm text-gray-500">
        Estética, tatuagem ou consultório médico? <span className="font-medium text-gray-700">Em breve</span> —
        nesses casos alguns municípios exigem responsável externo.
      </p>
    </section>
  )
}
